import { SdIcon } from './SdIcon';

/**
 * author: Google
 * id 68B68EDB-6CDA-4488-A213-5E6DF4146EA6
 * name sd
 * version: 1.5.54
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/sd.svg
 * tags
 */
export const SdCardIcon = SdIcon;
export default SdCardIcon